import { FaGithub } from 'react-icons/fa';
import { LogoProps } from './types';

const Github = ({ size = 24 }: LogoProps) => <FaGithub size={size} />;

export default Github;
